

import ColorDisclaimer from "./ColorDisclaimer";
import IndicationDisclaimer from "./commonComps/3DEmblem/IndicationDisclaimer";
import { Step } from "../../types/wizard";
import "./QuickView.css";

export default function QuickViewLayout({ columns }: { columns: { column: number; step: Step; content: JSX.Element }[] }) {
  const activeColumns = [1, 2, 3, 4].filter((col) =>
    columns.some((item) => item.column === col)
  );

  const columnWidth =
    activeColumns.length === 4 ? "w-1/4" : "w-1/3";

  const lastColumnTitle =
    columns.find((item) => item.column === 4)?.content?.props.step?.title || "";

  return (
    <div className="relative h-full">
      <div className="flex gap-2 items-start justify-start">
        {activeColumns.map((col) => {
          const columnData = columns?.find((item) => item.column === col);
          const step = columnData?.step;

          return <div
            key={col}
            className={`flex flex-col items-center justify-start relative text-left ml-4 mr-4 ${columnWidth}`}
          >
            {col === 1 && (
              <>
                <div className="w-full mb-4">
                  <h4 className="font-bold text-lg my-4">PRODUCT DETAIL</h4>
                  <hr className="dashed-title" />
                </div>
                {columns
                  .filter((item) => item.column === 1)
                  .map((item, index) => (
                    <div key={index} className="w-full">
                      {item.content}
                    </div>
                  ))}
              </>
            )}
            {col === 2 && (
              <>
                <div className="w-full mb-4">
                  <h4 className="font-bold text-lg my-4">DESIGN</h4>
                  <hr className="dashed-title" />
                </div>
                {columns
                  .filter((item) => item.column === 2)
                  .map((item, index) => {
                    return <div key={index} className="w-full">
                      {item.content}
                    </div>
                  })}
              </>
            )}
            {col === 3 && (
              <>
                <div className="w-full mb-4">
                  <h4 className="font-bold text-lg my-4">COLORS</h4>
                  <ColorDisclaimer
                    step={step}
                    title={"Let Stahls Choose My Colors"}
                  />
                  <hr className="dashed-title" />
                </div>
                {columns
                  .filter((item) => item.column === 3)
                  .map((item, index) => {
                    return <div key={index} className="w-full">
                      {item.content}
                    </div>
                  })}
              </>
            )}
            {col === 4 && (
              <>
                <div className="w-full mb-4">
                  <h4 className="font-bold text-lg my-4 uppercase">{lastColumnTitle}</h4>
                  <IndicationDisclaimer
                    step={step}
                    title={"Let Stahls Choose My Indications"}
                  />
                  <hr className="dashed-title" />
                </div>
                {columns
                  .filter((item) => item.column === 4)
                  .map((item, index) => {
                    return <div key={index} className="w-full">
                      {item.content}
                    </div>
                  })}
              </>
            )}
          </div>
        })}
      </div>
    </div>
  );
}